/* eslint-disable eqeqeq */
import React from 'react'
import { Link } from 'react-router-dom'

const Box = ({ icon, title, slug }) => {
  // service-hozori
  // service-online
  const setType = () => {
    if (slug == 'service-online') {
      localStorage.setItem('serviceType', 1)
    } else if (slug == 'service-hozori') {
      localStorage.setItem('serviceType', 2)
    }
  }

  return (
    <>
      {slug == 'shop' && (
        <Link to={`/shop`} className={`service-link-box`}>
          <div>{icon}</div>
          <div className='title'>{title}</div>
        </Link>
      )}
      {slug == 'library' && (
        <Link to={`/library`} className={`service-link-box`}>
          <div>{icon}</div>
          <div className='title'>{title}</div>
        </Link>
      )}
      {slug == 'map' && (
        <Link to={`/map`} className={`service-link-box`}>
          <div>{icon}</div>
          <div className='title'>{title}</div>
        </Link>
      )}
      {slug != 'library' && slug != 'map' && slug != 'shop' && (
        <Link
          to={`/service/${slug}`}
          onClick={() => setType()}
          className={`service-link-box`}
        >
          <div>{icon}</div>
          <div className='title'>{title}</div>
        </Link>
      )}
    </>
  )
}
export default Box
